import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ItemCounterComponent } from '@spartacus/storefront'
import { Subscription } from 'rxjs'
import { startWith } from 'rxjs/operators'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'

@Component({
  selector: 'mb-quantity-counter',
  templateUrl: './quantity-counter.component.html',
  styleUrls: ['./quantity-counter.component.scss']
})
export class QuantityCounterComponent extends ItemCounterComponent implements OnInit, OnDestroy {

  @Input() isDisplayedInCartPage = false

  private subscription: Subscription | null = null
  constructor (private globalMessageService: GlobalMessageService) { super()}

  ngOnInit (): void {
    this.subscription = this.control.valueChanges
    .pipe(startWith(this.control.value as number))
    .subscribe((value) =>
      this.control.setValue(this.getValidatedCount(value), { emitEvent: false })
    )
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  /**
   * return value be converted to int, in order to block copy & paste decimal inputs.
   */
  getValidatedCount (value: number) {
    if (value < this.min && !(value === 0 && this.allowZero)) {
      value = this.min
    }
    if (this.max && value > this.max) {
      value = this.max
      if(this.isDisplayedInCartPage) {
        this.globalMessageService.add({ key: 'quickOrderCartForm.stockLevelReached' }, GlobalMessageType.MSG_TYPE_WARNING)
      }
    }
    return parseInt(value.toString(), 10)
  }

}
